import React from 'react';

export default function InfoIcon() {
  return (
    <svg
      className="svg-icon"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      role="img"
      aria-labelledby="info-icon-title"
    >
      <title id="info-icon-title">Info Icon</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <path
            d={
              'M31.581913,5.41808696 C24.3572609,-1.80576087 ' +
              '12.6435435,-1.80656522 5.41808696,5.41808696 ' +
              'C-1.80656522,12.6427391 -1.80576087,24.3564565 ' +
              '5.41808696,31.581913 C12.6427391,38.8049565 24.3564565,38.8057609 ' +
              '31.581913,31.581913 C38.8057609,24.3564565 38.8049565,12.6435435 ' +
              '31.581913,5.41808696 Z M20.9122391,26.5434783 C20.9122391,27.8762826 ' +
              '19.832,28.9565217 18.4991957,28.9565217 C17.1663913,28.9565217 ' +
              '16.0861522,27.8762826 16.0861522,26.5434783 L16.0861522,16.8913043 ' +
              'C16.0861522,15.5585 17.1663913,14.4782609 18.4991957,14.4782609 ' +
              'C19.832,14.4782609 20.9122391,15.5585 20.9122391,16.8913043 ' +
              'L20.9122391,26.5434783 Z M18.4565652,12.7666087 ' +
              'C17.0666522,12.7666087 16.1400435,11.782087 16.169,10.5667174 ' +
              'C16.1400435,9.29263043 17.0666522,8.33786957 18.4847174,8.33786957 ' +
              'C19.903587,8.33786957 20.8012391,9.29343478 20.831,10.5667174 ' +
              'C20.8301957,11.782087 19.9043913,12.7666087 18.4565652,12.7666087 Z'
            }
          />
        </g>
      </g>
    </svg>
  );
}
